module.exports = __webpack_public_path__ + "static/media/company_logo.4aa15a1e.png";